import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { IVisitDetails } from '@app/shared/models/visit-details.model';
import { forkJoin, Observable, of, catchError, map, take } from 'rxjs';
import { VisitService } from '@app/shared/services/visit/visit.service';
import { isValidHttpUrl } from '@app/shared/utils/utils';
import { SimpleFlowDetectionService } from '@app/shared/services/simple-flow-detection/simple-flow-detection.service';

@Injectable({
  providedIn: 'root'
})
export class VisitDetailsResolverService implements Resolve<IVisitDetails> {

  constructor(private visitDetailsService: VisitService, private simpleFlow: SimpleFlowDetectionService) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<IVisitDetails | null> {
    const visitId = route.paramMap.get('visitId');
    const resolvedVisitDetails$ = this.visitDetailsService.getVisitDetails(visitId);
    const isSimpleFlow$ = this.simpleFlow.isSimpleFlow$().pipe(take(1));

    return forkJoin([resolvedVisitDetails$, isSimpleFlow$])
      .pipe(
        map(([visitDetails, isSimpleFlow]) => this.extendWithRouteInfo(visitDetails, isSimpleFlow)),
        catchError(() => of(null))
      );
  }

  private extendWithRouteInfo(visitDetails: IVisitDetails, isSimpleFlow: boolean): IVisitDetails {
    return {
      ...visitDetails,
      wasRoutedBySalonId: isSimpleFlow,
      canRedirectToSalonWebpageOnRouteBySalonId:
        isSimpleFlow &&
        visitDetails.bookingReturnUrl &&
        isValidHttpUrl(visitDetails.bookingReturnUrl)
    };
  }

}
